import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00ad2113"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

interface Props {
  title?: string
  hideBack?: boolean
  smallMargin?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VHeader',
  props: {
    title: null,
    hideBack: { type: Boolean },
    smallMargin: { type: Boolean }
  },
  emits: ['back'],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["v-header", { 'small-margin': __props.smallMargin }])
  }, [
    (!__props.hideBack)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: require('@/assets/icon/back.svg'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["v-header__body", { 'with-slot': !!_ctx.$slots.right }])
    }, [
      _createElementVNode("h1", null, _toDisplayString(__props.title), 1),
      _renderSlot(_ctx.$slots, "right")
    ], 2)
  ], 2))
}
}

})